import Home from "../Home";
import AdminDashboard from '../../pages/AdminDashboard';
import NfcUserScanner from '../../pages/NfcUserScanner';
import NfcManagement from '../../pages/NfcManagement';
import CheckpointManagement from '../../pages/CheckpointManagement';
import CheckpointVerification from '../Checkpoints/CheckpointVerification';
import ActiveCheckpoints from '../Checkpoints/ActiveCheckpoints';
import DepartmentManagementPage from '../../pages/DepartmentManagementPage';
import ProductsManagementPage from '../../pages/ProductsManagementPage';
import ProductDetailPage from '../Products/ProductDetailPage';
import OrderListPage from '../Orders/OrderListPage';
import OrderDetailPage from '../Orders/OrderDetailPage';
import OrderCreatePage from '../Orders/OrderCreatePage';
import { QRScannerPage } from '../../pages/QRScannerPage';
import { QRListPage } from '../../pages/QRListPage';
import HierarchicalAnalyticsPage from '../../pages/HierarchicalAnalyticsPage';
import SettingsPage from '../../pages/SettingsPage';

export const RoutesConfig = [
    {
        path: "/home",
        element: <Home />,
    },
    {
        path: "/departments",
        element: <DepartmentManagementPage />,
    },
    {
        path: "/products",
        element: <ProductsManagementPage />,
    },
    {
        path: "/products/:id",
        element: <ProductDetailPage />,
    },
    {
        path: "/nfc-scanner",
        element: <NfcUserScanner />,
    },
    {
        path: "/nfc-management",
        element: <NfcManagement />,
    },
    {
        path: "/checkpoints",
        element: <CheckpointManagement />,
    },
    {
        path: "/checkpoints/active",
        element: <ActiveCheckpoints />,
    },
    {
        path: "/checkpoint/:id",
        element: <CheckpointVerification />,
    },
    {
        path: "/admin/dashboard",
        element: <AdminDashboard />,
    },
	{
		path: "/orders",
		element: <OrderListPage />,
	},
	{
		path: "/orders/:id",
		element: <OrderDetailPage />,
	},
	{
		path: "/orders/create",
		element: <OrderCreatePage />,
	},
	{
		path: "/qr-scanner",
		element: <QRScannerPage />,
	},
	{
		path: "/qr-list",
		element: <QRListPage />,
	},
	{
		path: "/analytics/hierarchical",
		element: <HierarchicalAnalyticsPage />,
	},
    {
        path: "/settings",
        element: <SettingsPage />,
    },
];
